export const SPORT_TOGGLE_INPUT_LABEL = "Toggle Sports";



// WEBPACK FOOTER //
// ./src/pages/director/SurveyDataCenter/components/SportCheckboxes/constants.ts